import { DEFAULT_IMAGES } from '../constants/images.constants';
import { Gender } from './gender.enum';

export type FighterInfo = {
  CardId: number;
  FightId: string;
  FighterId: string;
  FighterImage: string;
  FighterName: string;
  Firstname: string;
  Lastname: string;
  Dob: Date | null;
  Opponent: string;
  FightDate: string;
  Points: number | null;
  Title: string;
  Gender: Gender | unknown;
};

export const defaultFighterInfo = (): FighterInfo => ({
  CardId: 0,
  FightId: '',
  FighterId: '',
  FighterImage: DEFAULT_IMAGES.FIGHTER_GENERIC,
  FighterName: 'No Fighter Selected',
  Firstname: '',
  Lastname: '',
  Dob: null,
  Opponent: '',
  FightDate: '',
  Points: null,
  Title: '',
  Gender: undefined as unknown,
});
